import styled from 'styled-components';

export const AgGridToolbarContainer = styled.div`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing.s4};
  padding-top: ${({ theme }) => theme.spacing.s1};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s3};
`;

export const AgGridToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s3};
`;
